// extracted by mini-css-extract-plugin
export default {"basicTransfer":"transfer__basicTransfer"};